<template>
  <b-modal
    :id="modalId"
    :modal-class="modalClasses"
    :hide-footer="true"
    @hidden="hidden"
    @shown="shown"
  >
    <template v-slot:modal-title>
      {{ modalTitle }}
    </template>

    <template v-slot:default>

      <AlertWraper
        :content="errors"
        type="error"
      />

      <!-- ACTUAL PURCHASE -->
      <div v-if="products.length > 0">
        <!-- PRODUCT LIST -->
        <div
          class="text-center font-size-small"
          v-if="step === 'product-list'"
        >
          <!-- STEP LOADER -->
          <div
            class="text-center"
            v-if="loader"
          >
            <Loader
              color="color2"
              size="big"
            />
          </div> <!-- END STEP LOADER -->
          <div v-else-if="localProducts.length > 0">
            <template v-if="productType === 'book'">
              <p class="col-md-8 mx-md-auto">Você está prestes a comprar o livro <span class="font-weight-bold text-color2">{{ singleProductTitle }}</span> por <span class="font-weight-bold text-color2">{{ (singleProduct.product.amount/100) | formatMoney }}</span></p>
              <div class="my-3">
                <div class="product-cover" :style="{ backgroundImage: `url('${singleProduct.product.cover}')` }"></div>
              </div>
              <div>
                <p>Caso sua compra seja recusada pelo emissor do cartão de crédito, tente novamente com outro cartão ou aprove o pagamento em seu aplicativo da operadora e realize uma nova compra.</p>
                <Button
                  class="btn-primary btn-sm"
                  @click="changeStep('payment-method')"
                >
                  Continuar
                </Button>
              </div>
            </template>
            <template v-else-if="productType === 'group'">
              <p class="col-md-9 mx-md-auto">Você está prestes a assinar a comunidade <span class="font-weight-bold text-color2">{{ singleProductTitle }}</span> por <span class="font-weight-bold text-color2">{{ (singleProduct.product.amount/100) | formatMoney }}</span> por mês, cobrados todo dia <span class="font-weight-bold text-color2">{{ currentDay }}</span>.</p>
              <div class="my-3">
                <div class="product-cover" :style="{ backgroundImage: `url('${singleProduct.product.cover}')` }"></div>
              </div>
              <div>
                <p>Caso sua compra seja recusada pelo emissor do cartão de crédito, tente novamente com outro cartão ou aprove o pagamento em seu aplicativo da operadora e realize uma nova compra.</p>
                <p><span class="font-weight-bold text-color2">Deseja continuar com a compra?</span></p>
                <Button
                  class="btn-primary btn-sm"
                  @click="changeStep('payment-method')"
                >
                  Continuar
                </Button>
              </div>
            </template>
            <template v-else-if="productType === 'donation'">
              <p class="col-md-9 mx-md-auto">Você está prestes a pagar um cafezinho para <span class="font-weight-bold text-color2">{{ singleProductTitle }}</span>!</p>
              <div class="mb-3">
                <div class="profile-image mx-auto" :style="profileImage"></div>
              </div>
              <p class="col-md-12 mx-md-auto">Por favor, selecione o valor que gostaria de enviar! Vale lembrar que o valor mínimo é de <strong>R$ 5,00</strong> e o pagamento é feito via PIX!</p>
              <div class="col-md-8 mx-md-auto mb-3">
                <Money
                  class="form-control bordered-bottom font-size-regular font-weight-bold text-color2 pb-0 px-0 w-100"
                  v-model="purchase.amount"
                  v-bind="money"
                />
              </div>
              <p class="font-size-xSmall mt-2 text-center text-color2 mb-0" v-if="purchase.amount > 9999">Valor máximo de: R$ 9999,00</p>
              <div class="mt-3 col-md-9 mx-md-auto" v-if="singleProduct.product.is_scriv_pro_donation_available">
                <p>Ou pague o cafezinho utilizando sua assinatura <strong>Scriv Pro</strong>!</p>
              </div>
              <Button
                class="btn-primary btn-sm"
                @click="changeStep('payment-method')"
                :disabled="purchase.amount < 5 || purchase.amount > 9999"
              >
                Continuar
              </Button>
              <Button
                class="btn-primary btn-sm ml-2"
                @click="openScrivProDonationModal"
                v-if="singleProduct.product.is_scriv_pro_donation_available"
              >
                Doar com Scriv Pro
              </Button>
            </template>
            <template v-else-if="productType === 'product'">
              <p class="col-md-9 mx-md-auto">Você está prestes a assinar o <span class="font-weight-bold text-color2">Scriv Pro</span> por <span class="font-weight-bold text-color2">{{ (singleProduct.product.amount/100) | formatMoney }}</span> por mês, cobrados todo dia <span class="font-weight-bold text-color2">{{ currentDay }}</span>.</p>
              <div>
                <p>Caso sua compra seja recusada pelo emissor do cartão de crédito, tente novamente com outro cartão ou aprove o pagamento em seu aplicativo da operadora e realize uma nova compra.</p>
                <Button
                  class="btn-primary btn-sm"
                  @click="changeStep('payment-method')"
                >
                  Continuar
                </Button>
              </div>
            </template>
          </div>
        </div>
        <!-- END PRODUCT LIST -->
        <!-- PAYMENT METHOD SELECT -->
        <div
          class="text-center font-size-small payment-method-selection"
          v-if="step === 'payment-method'"
        >
          <div>
            <ul class="d-flex flex-column align-items-center default-form col-md-8 mx-md-auto">
              <li
                class="w-100"
                v-for="(method, index) in paymentMethods"
                :key="index"
              >
                <div class="styled-radio-as-input d-flex h-100">
                  <input
                    type="radio"
                    :value="method"
                    v-model="purchase.paymentMethod"
                    class="d-none"
                    :id="method"
                  />
                  <label
                    class="w-100 d-flex align-items-center"
                    :for="method"
                  >
                    <img :src="`/images/icons/${method}.png`" alt="" />
                    {{ method | formatPaymentMethod }}
                  </label>
                </div>
              </li>
            </ul>
            <div v-if="isSubscription">
              <p class="text-center font-size-xSmall"><strong>Atenção:</strong> Essa será a forma de pagamento que usaremos para cobrar sua assinatura mensalmente!</p>
            </div>
          </div>
          <div>
            <Button
              class="btn-primary btn-sm"
              @click="purchase.paymentMethod === 'credit_card' ? changeStep('credit-card') : changeStep('customer')"
              :disabled="!purchase.paymentMethod"
            >
              Continuar
            </Button>
          </div>
        </div> <!-- END PAYMENT METHOD SELECT -->
        <!-- CREDIT CARD SELECT -->
        <div
          class="text-center font-size-small credit-card-selection"
          v-if="step === 'credit-card'"
        >
          <!-- STEP LOADER -->
          <div
            class="text-center"
            v-if="loader"
          >
            <Loader
              color="color2"
              size="big"
            />
          </div> <!-- END STEP LOADER -->
          <template v-else>
            <template v-if="!creditCardCreation">
              <!-- CARD LIST -->
              <template
                v-if="cards.length > 0"
              >
                <div class="d-flex flex-wrap">
                  <div
                    class="col-12 mb-3"
                    v-for="card in cards"
                    :key="card.id"
                  >
                    <label>
                      <input type="radio" :value="card.id" v-model="purchase.card" class="d-none" />
                      <CreditCardCard
                        class="cursor-pointer"
                        :card="card"
                        size="small"
                      />
                    </label>
                  </div>
                </div>
              </template> <!-- END CARD LIST -->
              <!-- NO CARDS -->
              <template v-else>
                <p>Não foram encontrados cartões de crédito cadastrados</p>
              </template> <!-- END NO CARDS -->
              <div class="">
                <Button
                  class="btn-outline-color2 btn-sm"
                  @click="creditCardCreation = true"
                >
                  Criar cartão
                </Button>
                <Button
                  class="btn-primary btn-sm ml-2"
                  @click="changeStep('customer')"
                  :disabled="!purchase.card"
                >
                  Avançar
                </Button>
              </div>
            </template>
            <!-- CREDIT CARD CREATION FORM -->
            <template
              v-else
            >
              <p class="mb-2">Preencha os dados do cartão</p>
              <CreditCardCreationForm
                @credit-card-created="parseCreatedCard"
              />
            </template> <!-- END CREDIT CARD CREATION FORM -->
          </template>
        </div> <!-- END CREDIT CARD SELECT -->
        <!-- CUSTOMER INFO -->
        <div
          class="text-center font-size-small"
          v-if="step === 'customer'"
        >
          <div class="default-form">
            <div class="form-group default-input">
              <TheMask
                :mask="'###.###.###-##'"
                v-model="$v.purchase.customer.document.$model"
                placeholder=""
                class="form-control with-label"
              />
              <label>CPF</label>
            </div>
            <div class="form-group default-input">
              <TheMask
                :mask="'(##) #####-####'"
                v-model="$v.purchase.customer.phone.$model"
                placeholder=""
                class="form-control with-label"
              />
              <label>Celular</label>
            </div>
            <template v-if="purchase.paymentMethod !== 'credit_card'">
              <div>
                <AddressForm
                  v-model="purchase.address"
                  @error="parseZipcodeError"
                  @get-zipcode-started="errors = null"
                />
              </div>
            </template>
          </div>
          <div class="mt-3">
            <Button
              class="btn-outline-color2 btn-sm"
              @click="changeStep('payment-method')"
            >
              Voltar
            </Button>
            <Button
              class="btn-primary btn-sm ml-2"
              @click="changeStep('confirm')"
              :disabled="$v.$invalid"
            >
              Avançar
            </Button>
          </div>
        </div> <!-- END CUSTOMER INFO -->
        <!-- CONFIRM PURCHASE -->
        <div
          class="text-center font-size-small"
          v-if="step === 'confirm'"
        >
          <template v-if="productType === 'donation'">
            <h2 class="font-weight-bold font-size-medium">Cafezinho</h2>
            <p class="col-md-8 mx-md-auto">Cafezinho para <span class="font-weight-bold text-color2">{{ singleProductTitle }}</span> no valor de <span class="font-weight-bold text-color2">{{ (purchase.amount) | formatMoney }}</span></p>
            <div class="my-3">
              <div class="profile-image profile-image-sm mx-auto" :style="profileImage"></div>
            </div>
          </template>
          <template v-else>
            <h2 class="font-weight-bold font-size-medium">Produto</h2>
            <p class="col-md-8 mx-md-auto"><span class="font-weight-bold text-color2">{{ singleProductTitle }}</span> por <span class="font-weight-bold text-color2">{{ (singleProduct.product.amount/100) | formatMoney }}</span> {{ productType === 'group' || productType === 'product' ? 'por mês' : '' }}</p>
            <div class="my-3" v-if="productType !== 'product'">
              <img :src="singleProduct.product.cover" class="image" :alt="singleProductTitle" />
            </div>
          </template>
          <h2 class="font-weight-bold font-size-medium">Pagamento</h2>
          <p>{{ purchase.paymentMethod | formatPaymentMethod }}</p>
          <template
            v-if="isSubscription"
          >
            <p><strong>Dia de cobrança:</strong> Todo dia {{ currentDay }}</p>
            <p class="text-center font-size-xSmall" >
              <strong>Atenção:</strong> Você está prestes a realizar uma assinatura recorrente e essa será a forma de pagamento que usaremos para cobrar sua assinatura mensalmente. <br/>Você pode alterar a forma de pagamento na página "Minhas assinaturas".
            </p>
          </template>
          <template
            v-if="purchase.paymentMethod === 'credit_card'"
          >
            <h2 class="font-weight-bold font-size-medium">Cartão</h2>
            <CreditCardCard
              class="my-3"
              :card="selectedCard"
              size="small"
            />
          </template>
          <template
            v-else
          >
            <h2 class="font-weight-bold font-size-medium">Endereço</h2>
            <p>
              <strong>CEP:</strong> {{ purchase.address.zipcode | VMask('#####-###') }}<br/>
              <strong>Rua:</strong> {{ purchase.address.street }}<br/>
              <strong>Número:</strong> {{ purchase.address.number }}<br/>
              <strong>Complemento:</strong> {{ purchase.address.complement }}<br/>
              <strong>Bairro:</strong> {{ purchase.address.neighborhood }}<br/>
              <strong>Cidade:</strong> {{ purchase.address.city }}<br/>
              <strong>Estado:</strong> {{ purchase.address.state }}
            </p>
          </template>
          <h2 class="font-weight-bold font-size-medium">Comprador</h2>
          <p>
            <strong>CPF:</strong> {{ purchase.customer.document | VMask('###.###.###-##') }}<br/>
            <strong>Celular:</strong> {{ purchase.customer.phone | VMask('(##) #####-####') }}
          </p>

          <div class="mt-3">
            <Button
              class="btn-outline-color2 btn-sm"
              @click="changeStep('customer')"
            >
              Voltar
            </Button>
            <Button
              class="btn-primary btn-sm ml-2"
              @click="submit"
              :loading="loader"
            >
              Finalizar {{ productType !== 'donation' ? 'compra' : '' }}
            </Button>
          </div>
        </div> <!-- END CONFIRM PURCHASE -->
        <!-- PIX PAYMENT STEP -->
        <div class="text-center font-size-small" v-if="step === 'pix-payment'">
          <p>Falta pouco! Para finalizar, escaneie o QR Code a seguir com o seu aplicativo e pague com PIX.</p>
          <p>Assim que o pagamento por processado, você receberá um e-mail de confirmação!</p>
          <div class="mx-auto mb-4">
            <QRCodeCard
              :code="invoice.pix_qr_code"
              v-if="invoice"
            />
          </div>
          <Button
            class="btn-outline-color2 btn-sm"
            @click="$bvModal.hide('checkout-modal')"
          >
            Fechar
          </Button>
        </div> <!-- END PIX PAYMENT STEP -->
      </div> <!-- END ACTUAL PURCHASE -->
      <!-- EMPTY CART -->
      <div v-else>
        <p class="text-center">
          Não há produtos no carrinho
        </p>
      </div> <!-- END EMPTY CART -->
    </template>
  </b-modal>
</template>

<script>

import BooksService from '@/modules/books/services/books-service'
import CreditCardsService from '@/modules/credit-cards/services/credit-cards-service'
import CheckoutService from '@/modules/checkout/services/checkout-service'
import GroupsService from '@/modules/groups/services/groups-service'
import NotificationService from '@/modules/notifications/services/notifications-service'
import moment from 'moment'
import ProductsService from '@/modules/products/services/products-service'
import UsersService from '@/modules/users/services/users-service'
import { parseErrorResponseToArray } from '@/utils'
import { required } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'
import variables from '@/mixins/variables'

import AlertWraper from '@/components/common/Alert/AlertWraper'
import AddressForm from '@/components/common/Address/AddressForm'
import Button from '@/components/common/Button/Button'
import CreditCardCard from '@/components/credit-cards/CreditCardCard'
import CreditCardCreationForm from '@/components/credit-cards/CreditCardCreationForm'
import Loader from '@/components/common/Loader/Loader'
import { Money } from 'v-money'
import QRCodeCard from '@/components/common/QRCode/QRCodeCard'
import { TheMask } from 'vue-the-mask'

export default {
  name: 'TheCheckoutModal',
  mixins: [variables],
  props: {
    products: {
      type: Array,
      default: function () {
        return []
      }
    },
    paymentMethods: {
      type: Array,
      default: function () {
        return []
      }
    },
    modalId: {
      type: String,
      default: 'checkout-modal'
    }
  },
  components: {
    AlertWraper,
    AddressForm,
    Button,
    CreditCardCard,
    CreditCardCreationForm,
    Loader,
    Money,
    QRCodeCard,
    TheMask
  },
  data () {
    return {
      errors: null,
      loader: null,
      step: 'product-list',
      localProducts: [],
      cards: [],
      creditCardCreation: false,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
      purchase: {
        amount: 0,
        card: '',
        customer: {
          phone: '',
          document: ''
        },
        paymentMethod: '',
        address: {
          street: '',
          number: '',
          neighborhood: '',
          city: '',
          state: '',
          zipcode: '',
          complement: ''
        }
      },
      invoice: null
    }
  },
  validations () {
    if (this.step === 'customer') {
      const validation = {
        purchase: {
          customer: {
            document: { required },
            phone: { required }
          }
        }
      }

      if (this.purchase.paymentMethod !== 'credit_card') {
        const address = {
          street: { required },
          number: { required },
          neighborhood: { required },
          city: { required },
          state: { required },
          zipcode: { required }
        }
        validation.purchase.address = address
      }

      return validation
    }

    return ''
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    }),
    ...mapState({
      nightMode: state => state.nightMode
    }),
    modalClasses () {
      return {
        'default-modal': true
      }
    },
    modalTitle () {
      if (this.step === 'product-list') {
        if (this.productType === 'book') return 'Comprar livro'
        else if (this.productType === 'group') return 'Assinar comunidade'
        else if (this.productType === 'donation') return 'Pagar um cafezinho'
        else if (this.productType === 'product') return 'Assinar Scriv Pro'
      }
      if (this.step === 'payment-method') return 'Selecione uma forma de pagamento'
      if (this.step === 'credit-card') return 'Selecione o cartão'
      if (this.step === 'customer') return 'Informações do pagador'
      if (this.step === 'confirm') return 'Confirme os dados'
      if (this.step === 'pix-payment') return 'Conclua com o PIX'

      return 'Finalize sua compra'
    },
    productType () {
      if (this.products.length > 1) return 'mixed'
      if (this.products.length === 1) return this.products[0].type
      return ''
    },
    /**
     * User profile image
     */
    profileImage () {
      return {
        backgroundImage: this.productType === 'donation' && this.singleProduct.product ? `url('${this.singleProduct.product.avatar}')` : `url('${this.noAvatarUrl}')`
      }
    },
    isSingleProduct () {
      return this.products.length === 1
    },
    singleProduct () {
      if (this.isSingleProduct && this.localProducts.length > 0) return this.localProducts[0]

      return null
    },
    singleProductTitle () {
      if (this.productType === 'book') return this.singleProduct.product.title
      else if (this.productType === 'group') return this.singleProduct.product.name
      else if (this.productType === 'donation') return this.singleProduct.product.name
      else if (this.productType === 'product') return this.singleProduct.product.name
      return ''
    },
    isSubscription () {
      return this.productType === 'group' || this.productType === 'product'
    },
    selectedCard () {
      const index = this.cards.findIndex(c => c.id === this.purchase.card)
      if (index < 0) return null
      return this.cards[index]
    },
    currentDay () {
      return moment().format('DD')
    }
  },
  methods: {
    shown () {
      if (this.user) {
        this.purchase.customer.document = this.user.document
        this.purchase.customer.phone = this.user.phone
        // eslint-disable-next-line no-undef
        gtag('set', 'user_data', {
          email: this.user.email
        })
      }
      this.getProducts()
    },
    hidden () {
      this.reset()
    },
    changeStep (step) {
      this.step = step

      if (step === 'credit-card') {
        this.getCreditCards()
      }
    },
    async submit () {
      this.loader = true
      try {
        const invoice = await CheckoutService.purchase({
          productType: this.productType,
          cardId: this.purchase.card,
          productId: this.singleProduct.product.id,
          customer: this.purchase.customer,
          address: this.purchase.address,
          paymentMethod: this.purchase.paymentMethod,
          amount: this.purchase.amount
        })
        this.invoice = invoice
        if (invoice.payment_method !== 'pix') {
          this.$bvModal.hide('checkout-modal')
          const notification = {
            notification: {
              type: 'success',
              content: 'Compra realizada e sendo processada com sucesso!'
            }
          }
          NotificationService.createGlobalSuccessNotification(notification)
        } else {
          this.step = 'pix-payment'
        }
        // Send gtag event depending on type of purchase
        let conversionId = null
        switch (this.productType) {
          case 'group':
            conversionId = 'AW-379744698/JUNsCJr8k9sDELrjibUB'
            break
          case 'book':
            conversionId = 'AW-379744698/ZQJbCKvvk9sDELrjibUB'
            break
          case 'donation':
            conversionId = 'AW-379744698/BGFdCLmAlNsDELrjibUB'
            break
          case 'product':
            conversionId = 'AW-379744698/Sc_VCJvDwJoYELrjibUB'
            break
          default:
            conversionId = null
            break
        }
        // eslint-disable-next-line no-undef
        gtag('event', 'conversion', {
          send_to: conversionId,
          value: parseInt(invoice.amount) / 100,
          currency: 'BRL',
          transaction_id: invoice.order.id
        })
        const googleItems = [{
          name: this.singleProductTitle,
          quantity: 1,
          price: parseInt(invoice.amount) / 100
        }]
        // eslint-disable-next-line no-undef
        gtag('event', 'purchase', {
          transaction_id: invoice.order.id,
          value: parseInt(invoice.amount) / 100,
          items: googleItems
        })
        this.$emit('purchase-completed', invoice)
      } catch (error) {
        this.errors = parseErrorResponseToArray(error)
      }
      this.loader = false
    },
    reset () {
      this.errors = null
      this.step = 'product-list'
      this.localProducts = []
      this.cards = []
      this.creditCardCreation = false
      this.purchase.card = ''
      this.purchase.customer.phone = ''
      this.purchase.customer.document = ''
      this.purchase.paymentMethod = ''
      this.purchase.address.street = ''
      this.purchase.address.number = ''
      this.purchase.address.zipcode = ''
      this.purchase.address.city = ''
      this.purchase.address.state = ''
      this.purchase.address.neighborhood = ''
      this.purchase.address.complement = ''
      this.invoice = null
    },
    async getProducts () {
      this.errors = null
      this.loader = true
      for (let i = 0; i < this.products.length; i++) {
        const p = this.products[i]
        if (p.type === 'book') {
          try {
            const product = await BooksService.getBook(p.slug)
            this.localProducts.push({
              type: 'book',
              product: product
            })
          } catch (error) {
            this.errors = parseErrorResponseToArray(error)
          }
        } else if (p.type === 'group') {
          try {
            const product = await GroupsService.getGroup(p.slug)
            this.localProducts.push({
              type: 'group',
              product: product
            })
          } catch (error) {
            this.errors = parseErrorResponseToArray(error)
          }
        } else if (p.type === 'donation') {
          try {
            const product = await UsersService.getUser(p.slug)
            this.localProducts.push({
              type: 'donation',
              product: product
            })
          } catch (error) {
            this.errors = parseErrorResponseToArray(error)
          }
        } else if (p.type === 'product') {
          try {
            const product = await ProductsService.getProduct(p.id)
            this.localProducts.push({
              type: 'product',
              product: product
            })
          } catch (error) {
            this.errors = parseErrorResponseToArray(error)
          }
        }
      }
      this.loader = false
    },
    async getCreditCards () {
      this.loader = true
      this.errors = null
      try {
        const cards = await CreditCardsService.getCreditCards()
        this.cards = cards
      } catch (error) {
        this.errors = parseErrorResponseToArray(error)
      }
      this.loader = false
    },
    parseCreatedCard (card) {
      this.creditCardCreation = false
      this.getCreditCards()
    },
    parseZipcodeError (error) {
      this.errors = error
    },
    openScrivProDonationModal () {
      this.$bvModal.hide(this.modalId)
      this.$bvModal.show('scriv-pro-donation-modal')
    }
  }
}
</script>

<style lang="scss" scoped>

.product-cover {
  display: block;
  width: 100%;
  height: 160px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  margin: 0 auto;
  -webkit-box-shadow: 0 0 10px 0 rgba(0,0,0,0.1);
  box-shadow: 0 0 10px 0 rgba(0,0,0,0.1);
  -webkit-border-radius: $radius_regular;
  -moz-border-radius: $radius_regular;
  border-radius: $radius_regular;
}

.credit-card-selection {
  ::v-deep {
    input:checked + .credit-card-wrap {
      border: 1px solid $color2;
    }
  }
}

.payment-method-selection {
  img {
    width: 40px;
    margin-right: 10px;
  }
}

.profile-image {
  -webkit-border-radius: 150px;
  -moz-border-radius: 150px;
  border-radius: 150px;
  -webkit-box-shadow: 0 0 10px 0 rgba(0,0,0,0.2);
  box-shadow: 0 0 10px 0 rgba(0,0,0,0.2);
  width: 100px;
  height: 100px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  @include tablet {
    height: 150px;
    width: 150px;
  }

  &.profile-image-sm {
    width: 100px;
    height: 100px;
  }
}

</style>
